import React from 'react';
import { Flex, Box } from '@wegroup/design-system';
import Avatar from '../../../../../../../sales-conversation/src/components/default/ProdFacAvatar';

const SmallToolbar: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      direction={{ base: 'row', laptop: 'column' }}
      bg="secondary.800"
      flexShrink={0}
      padding={{ base: '3', tablet: '6' }}
      borderTopRightRadius={{ laptop: '20px' }}
      zIndex="1"
    >
      <Box
        display={{ base: 'none', laptop: 'block' }}
        w="12"
        h="12"
        sx={{ img: { w: '100%', h: '100%' } }}
      >
        <Avatar />
      </Box>
      {children}
    </Flex>
  );
};

export default SmallToolbar;
